import { put, take } from "redux-saga/effects";

import { APP_READY } from "../CONSTANTS";
import { CONSTANTS as USER } from "@lifepay/redux-subsystem-user";
import { CONSTANTS as ACCESS } from "@lifepay/redux-subsystem-access";

export default function* onAppReady() {
  yield take(APP_READY);
  yield put({ type: USER.START });
  yield take(USER.STARTED);
  yield put({ type: ACCESS.START });
  yield take(ACCESS.STARTED);
  yield put({ type: USER.CONFIRM_SESSION_STATUS });
}



// WEBPACK FOOTER //
// ./src/model/subsystems/app/saga/onAppReady.js